import { StudentAbsenceReason } from '../enums/student-absence-reason.enum';

export const STUDENT_ABSENCE_REASON = {
  [StudentAbsenceReason.Family]: 'FAMILY',
  [StudentAbsenceReason.Medical]: 'MEDICAL',
};
